import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';

const Label = ({
  text, required, classes, htmlFor,
}) => (
  <label className={classes.label} htmlFor={htmlFor}>
    {`${text}${required ? '*' : ''}`}
  </label>
);

Label.defaultProps = {
  required: false,
  htmlFor: '',
};

Label.propTypes = {
  text: PropTypes.string.isRequired,
  required: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  htmlFor: PropTypes.string,
};

export default compose(
  injectSheet({
    label: {
      color: 'inherit',
      marginRight: 16,
      marginBottom: 4,
      '&:last-child': {
        marginRight: 0,
      },
    },
  }),
)(Label);
